module.exports = function drawStarstruck(ctx) {
  ctx.save();
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(19, 0);
  ctx.lineTo(19, 16);
  ctx.lineTo(0, 16);
  ctx.closePath();
  ctx.clip();
  ctx.strokeStyle = 'rgba(0,0,0,0)';
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.fillStyle = '#ffdf40';
  ctx.beginPath();
  ctx.arc(9.4707, 8, 8, 0, 6.283185307179586, true);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#66342d';
  ctx.strokeStyle = '#66342d';
  ctx.lineWidth = 0.3806400001049042;
  ctx.globalAlpha = 1;
  ctx.beginPath();
  ctx.moveTo(14.3236, 10.2406);
  ctx.bezierCurveTo(14.3689, 10.2276, 14.4105, 10.2153, 14.4482, 10.2039);
  ctx.bezierCurveTo(14.3644, 11.2596, 13.7855, 12.2704, 12.9223, 13.0403);
  ctx.bezierCurveTo(11.9879, 13.8737, 10.7369, 14.4091, 9.46906, 14.4091);
  ctx.bezierCurveTo(8.20127, 14.4091, 6.95021, 13.8737, 6.01579, 13.0403);
  ctx.bezierCurveTo(5.1526, 12.2704, 4.57377, 11.2596, 4.48991, 10.2039);
  ctx.bezierCurveTo(4.52764, 10.2153, 4.56923, 10.2276, 4.61457, 10.2406);
  ctx.bezierCurveTo(4.86487, 10.3129, 5.22966, 10.4087, 5.69072, 10.5045);
  ctx.bezierCurveTo(6.61262, 10.6959, 7.92078, 10.8871, 9.46906, 10.8871);
  ctx.bezierCurveTo(11.0173, 10.8871, 12.3255, 10.6959, 13.2474, 10.5045);
  ctx.bezierCurveTo(13.7085, 10.4087, 14.0733, 10.3129, 14.3236, 10.2406);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#f5f6e8';
  ctx.globalAlpha = 1;
  ctx.beginPath();
  ctx.moveTo(13.8016, 11.5358);
  ctx.bezierCurveTo(13.9676, 11.2168, 14.0873, 10.8837, 14.1533, 10.5447);
  ctx.bezierCurveTo(13.9234, 10.6062, 13.636, 10.6765, 13.2981, 10.7467);
  ctx.bezierCurveTo(12.3631, 10.9408, 11.0379, 11.1344, 9.46967, 11.1344);
  ctx.bezierCurveTo(7.90142, 11.1344, 6.57623, 10.9408, 5.64123, 10.7467);
  ctx.bezierCurveTo(5.30331, 10.6765, 5.01595, 10.6062, 4.78604, 10.5447);
  ctx.bezierCurveTo(4.85204, 10.8837, 4.97172, 11.2168, 5.13773, 11.5358);
  ctx.bezierCurveTo(5.92014, 11.9782, 7.38726, 12.5976, 9.46967, 12.5976);
  ctx.bezierCurveTo(11.5521, 12.5976, 13.0192, 11.9782, 13.8016, 11.5358);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#fff79c';
  ctx.beginPath();
  ctx.moveTo(4.29438, 1.32027);
  ctx.bezierCurveTo(4.31353, 1.24989, 4.40147, 1.22633, 4.45323, 1.2777);
  ctx.lineTo(6.21781, 3.02887);
  ctx.bezierCurveTo(6.23678, 3.04769, 6.26278, 3.05767, 6.28946, 3.05638);
  ctx.lineTo(8.77256, 2.93574);
  ctx.bezierCurveTo(8.84541, 2.9322, 8.89499, 3.00856, 8.86213, 3.07366);
  ctx.lineTo(7.74196, 5.29302);
  ctx.bezierCurveTo(7.72992, 5.31687, 7.72846, 5.34468, 7.73794, 5.36966);
  ctx.lineTo(8.61999, 7.69395);
  ctx.bezierCurveTo(8.64587, 7.76214, 8.58857, 7.83289, 8.5165, 7.82176);
  ctx.lineTo(6.05961, 7.44223);
  ctx.bezierCurveTo(6.03321, 7.43815, 6.00631, 7.44536, 5.98548, 7.46209);
  ctx.lineTo(4.04752, 9.01922);
  ctx.bezierCurveTo(3.99067, 9.0649, 3.90567, 9.03227, 3.89398, 8.96028);
  ctx.lineTo(3.49572, 6.50636);
  ctx.bezierCurveTo(3.49144, 6.47999, 3.47627, 6.45663, 3.45392, 6.442);
  ctx.lineTo(1.37414, 5.08006);
  ctx.bezierCurveTo(1.31313, 5.04011, 1.31789, 4.94919, 1.38275, 4.91583);
  ctx.lineTo(3.5935, 3.77876);
  ctx.bezierCurveTo(3.61725, 3.76654, 3.63478, 3.74489, 3.64179, 3.71912);
  ctx.lineTo(4.29438, 1.32027);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#fff79c';
  ctx.beginPath();
  ctx.moveTo(14.4908, 1.27766);
  ctx.bezierCurveTo(14.5426, 1.22629, 14.6305, 1.24985, 14.6497, 1.32023);
  ctx.lineTo(15.3023, 3.71907);
  ctx.bezierCurveTo(15.3093, 3.74485, 15.3268, 3.7665, 15.3506, 3.77872);
  ctx.lineTo(17.5613, 4.91579);
  ctx.bezierCurveTo(17.6262, 4.94915, 17.6309, 5.04007, 17.5699, 5.08002);
  ctx.lineTo(15.4901, 6.44195);
  ctx.bezierCurveTo(15.4678, 6.45659, 15.4526, 6.47995, 15.4483, 6.50632);
  ctx.lineTo(15.0501, 8.96024);
  ctx.bezierCurveTo(15.0384, 9.03223, 14.9534, 9.06486, 14.8965, 9.01918);
  ctx.lineTo(12.9586, 7.46205);
  ctx.bezierCurveTo(12.9378, 7.44531, 12.9109, 7.43811, 12.8845, 7.44218);
  ctx.lineTo(10.4276, 7.82172);
  ctx.bezierCurveTo(10.3555, 7.83285, 10.2982, 7.7621, 10.3241, 7.69391);
  ctx.lineTo(11.2061, 5.36962);
  ctx.bezierCurveTo(11.2156, 5.34464, 11.2141, 5.31683, 11.2021, 5.29298);
  ctx.lineTo(10.0819, 3.07362);
  ctx.bezierCurveTo(10.0491, 3.00851, 10.0987, 2.93216, 10.1715, 2.9357);
  ctx.lineTo(12.6546, 3.05633);
  ctx.bezierCurveTo(12.6813, 3.05763, 12.7073, 3.04765, 12.7263, 3.02883);
  ctx.lineTo(14.4908, 1.27766);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};
